module.exports = __webpack_public_path__ + "fonts/iconfont.cb07adcd.woff";